import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
export function Steps() {
  const steps = [{
    num: '1',
    text: 'Descarga la guía y haz el inventario de tu despensa (te diremos qué desechar hoy mismo).'
  }, {
    num: '2',
    text: 'Usa la Lista de Compras en tu próximo viaje al supermercado (presupuesto amigable).'
  }, {
    num: '3',
    text: 'Sigue el plan de 14 días y nota cómo la inflamación cede y tu movilidad regresa.'
  }];
  return <AnimatedSection className="py-24 px-6 max-w-5xl mx-auto" data-id="element-153">
      <h2 className="text-3xl md:text-4xl font-bold mb-16 text-center" data-id="element-154">
        ¿Cómo funciona?
      </h2>
      <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-155">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-brand-green/20 -z-10" data-id="element-156"></div>

        {steps.map((step, i) => <div key={i} className="flex flex-col items-center text-center relative" data-id="element-157">
            <div className="w-24 h-24 bg-brand-cream border-4 border-brand-green text-brand-green rounded-full flex items-center justify-center text-4xl font-bold mb-6 shadow-lg font-serif" data-id="element-158">
              {step.num}
            </div>
            <p className="text-xl font-medium px-4" data-id="element-159">{step.text}</p>
          </div>)}
      </div>
    </AnimatedSection>;
}